document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.querySelector('select.variant-option__select[name="options[Size]"]');
  const firmnessSelect = document.querySelector('select.variant-option__select[name="options[Firmness]"]');
  const localSelectedValue = localStorage.getItem('sticky-sizing-selected-value');
  const url = new URL(window.location.href);
  const hasUrlVariantSelection = url.searchParams.has('variant') || url.searchParams.has('option_values');

  // If the variant select is not found, return
  if (!(variantSelect instanceof HTMLSelectElement)) {
    return;
  }

  // If the firmness select is found
  if ((firmnessSelect instanceof HTMLSelectElement)) {
    const firmnessSelectedValue = firmnessSelect.value;
    const firmnessDefault = firmnessSelect.getAttribute('data-default-firmness');

    // console.log('**** firmnessSelect', firmnessSelect);
    // console.log('**** firmnessSelectedValue', firmnessSelectedValue);
    // console.log('**** firmnessDefault', firmnessDefault);

    // If the firmness default is set and there is no URL variant selection, set the firmness select to the default
    if (firmnessDefault && !hasUrlVariantSelection) {
      // console.log('**** setting firmnessDefault', firmnessDefault);

      firmnessSelect.value = firmnessDefault;
      firmnessSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // console.log('**** localSelectedValue', localSelectedValue);
  // console.log('**** hasUrlVariantSelection', hasUrlVariantSelection);

  // URL variant selections should win over sticky sizing on page load.
  if (localSelectedValue && !hasUrlVariantSelection) {
    const localSelectedOption = variantSelect.querySelector(`option[value="${localSelectedValue}"]`);

    // console.log('**** localSelectedOption', localSelectedOption);

    // If the local selected option is not found, return
    if (!localSelectedOption) {
      return;
    }

    // Set the value of the variant select
    variantSelect.value = localSelectedValue;

    // Trigger the change event on the variant select
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Variant selection change event listener
  variantSelect.addEventListener('change', (event) => {
    // If the event target is not a select element, return
    if (!(event.target instanceof HTMLSelectElement)) return;

    // Get the selected value
    const selectedValue = event.target.value;

    // console.log('**** variant-picker-sticky-sizing.js 41 selectedValue', selectedValue);

    // If the selected value is not a string, return
    if (!selectedValue || typeof selectedValue !== 'string') {
      return;
    }

    // Set the local storage item with the selected value
    localStorage.setItem('sticky-sizing-selected-value', selectedValue);
  });
});